<template>
  <v-card>
    <v-container fluid>
      <v-row dense align="center">
        <v-col class="font-weight-bold text-capitalize">
          Atestado {{ index + 1 }} -
          {{ medicalCertificate.medicalCertificateType }}
        </v-col>

        <v-col cols="auto">
          <authorization
            permissionKey="attendance_medical_certificate"
            can="print"
            v-slot:default="{ authorization }"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  :attrs="attrs"
                  v-on="on"
                  :disabled="false"
                  :loading="printLoading"
                  @click="downloadArchive"
                  v-if="authorization || forcePrint"
                >
                  <v-icon>eva-printer-outline</v-icon>
                </v-btn>
              </template>
              <span> Imprimir </span>
            </v-tooltip>
          </authorization>

          <authorization
            v-if="allowEdit"
            permissionKey="attendance_medical_certificate"
            can="save"
            v-slot:default="{ authorization }"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  :attrs="attrs"
                  v-on="on"
                  :to="`atestados/${medicalCertificate.id}`"
                  v-if="authorization"
                  :disabled="signed"
                >
                  <v-icon>eva-edit-outline</v-icon>
                </v-btn>
              </template>

              <span> Editar </span>
            </v-tooltip>
          </authorization>

          <authorization
            v-if="allowDelete"
            permissionKey="attendance_medical_certificate"
            can="delete"
            v-slot:default="{ authorization }"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  :attrs="attrs"
                  v-on="on"
                  @click="deleteCertificate"
                  v-if="authorization"
                  :disabled="signed"
                >
                  <v-icon>eva-trash-outline</v-icon>
                </v-btn>
              </template>

              <span> Excluir </span>
            </v-tooltip>
          </authorization>

          <v-btn icon small @click="showContent = !showContent">
            <v-icon v-if="showContent">eva-chevron-up-outline</v-icon>
            <v-icon v-else>eva-chevron-down-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row dense v-show="showContent">
        <v-col>
          <v-divider />

          <v-row>
            <v-col class="text">
              {{ medicalCertificate.text }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "MedicalCertificateListItem",
  props: {
    medicalCertificate: Object,
    index: Number,
    refreshList: Function,
    allowEdit: {
      type: Boolean,
      default: true,
    },
    allowDelete: {
      type: Boolean,
      default: true,
    },
    forcePrint: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      printLoading: false,
      showContent: true,
    };
  },
  computed: {
    signed() {
      return this.medicalCertificate.lastEsign.status !== "editable";
    },
  },
  methods: {
    deleteCertificate() {
      if (this.signed) return;
      if (confirm("Você realmente deseja deletar esse atestado?")) {
        this.apolloMutate({
          mutation: require("@/graphql/medical_certificate/delete_medical_certificate.gql"),
          variables: {
            medicalCertificateId: this.medicalCertificate.id,
          },
        }).then(() => {
          this.refreshList();
          this.$store.dispatch("createNotification", {
            message: "Atestado deletado com sucesso.",
            type: "success",
          });
        });
      }
    },
    async generatePreview() {
      await this.apolloMutate({
        mutation: require("@/graphql/esign/generate_preview.gql"),
        variables: {
          esignId: this.medicalCertificate.lastEsign.id,
          dynamicForm: true,
          examAppraisal: true,

        },
      });
    },
    async downloadArchive() {
      this.printLoading = true;
      await this.generatePreview();
      await this.refreshList();

      //await this.$store.dispatch("authentication/refreshToken");
      //if (this.medicalCertificate.lastEsign.status === "signed") {
      const file_url = this.medicalCertificate.lastEsign.fileUrl;

      await window.open(`${process.env.VUE_APP_BASE_URL}${file_url}`, "_blank");
      // } else {
      //   this.$store.dispatch("createNotification", {
      //     message: "É necessário assinar antes de imprimir.",
      //     type: "error",
      //   });
      // }

      this.printLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.text {
  white-space: pre-line;
}
</style>
